import SentimentTrackerOnboardingOverviewContainer from "./SentimentTrackerOnboardingOverviewContainer";
import SentimentTrackerOnboardingOverviewStore from "./SentimentTrackerOnboardingOverviewStore";

export default SentimentTrackerOnboardingOverviewStore(SentimentTrackerOnboardingOverviewContainer);